import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./updateappearance.css";

const hairColorOptions = ["Black", "Brown", "Red", "Blonde", "Gray"];
const eyeColorOptions = ["Black", "Brown", "Blue", "Green", "Gray"];

const UpdateAppearance = ({ initialInfo, onSave, onClose }) => {
  // Split the initial height into feet and inches if it exists
  const initialHeight = initialInfo.height || "";
  const initialFeet = initialHeight ? initialHeight?.split("ft")[0] : "";
  const initialInches = initialHeight ? initialHeight?.split(" ")[1].split("in")[0] : "";

  const [feet, setFeet] = useState(initialFeet);
  const [inches, setInches] = useState(initialInches);
  const [weight, setWeight] = useState(initialInfo.weight || "");
  const [hairColor, setHairColor] = useState(initialInfo.hairColor || "");
  const [eyeColor, setEyeColor] = useState(initialInfo.eyeColor || "");

  useEffect(() => {
    const initialHeight = initialInfo.height || "";
    const initialFeet = initialHeight ? initialHeight.split("ft")[0] : "";
    const initialInches = initialHeight ? initialHeight.split(" ")[1].split("in")[0] : "";

    setFeet(initialFeet);
    setInches(initialInches);
    setWeight(initialInfo.weight || "");
    setHairColor(initialInfo.hairColor || "");
    setEyeColor(initialInfo.eyeColor || "");
  }, [initialInfo]);

  const handleSave = () => {
    // Combine feet and inches into the desired format
    const height = `${feet}ft ${inches}in`;

    if (typeof onSave === "function") {
      onSave({ height, weight, hairColor, eyeColor });
    } else {
      console.error("onSave is not a function");
    }
    onClose();
  };

  return (
    <div className="update-appearance-popup-overlay">
      <div className="update-appearance-popup-content">
        <h2 className="update-appearance-popup-title">Edit Appearance</h2>
        <form className="update-appearance-form">
          <div className="update-appearance-form-group">
            <label htmlFor="height">Height</label>
            <div className="height-input-group">
              <input
                id="feet"
                type="text"
                value={feet}
                onChange={(e) => setFeet(e.target.value)}
                placeholder="Feet"
                className="update-appearance-input"
              />
              <input
                id="inches"
                type="text"
                value={inches}
                onChange={(e) => setInches(e.target.value)}
                placeholder="Inches"
                className="update-appearance-input"
              />
            </div>
          </div>
          <div className="update-appearance-form-group">
            <label htmlFor="weight">Weight (lbs)</label>
            <input
              id="weight"
              type="text"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
              placeholder="Enter weight"
              className="update-appearance-input"
            />
          </div>
          <div className="update-appearance-form-group">
            <label htmlFor="hairColor">Hair Color</label>
            <select
              id="hairColor"
              value={hairColor}
              onChange={(e) => setHairColor(e.target.value)}
              className="update-appearance-input"
            >
              <option value="">Select hair color</option>
              {hairColorOptions.map((color) => (
                <option key={color} value={color}>
                  {color}
                </option>
              ))}
            </select>
          </div>
          <div className="update-appearance-form-group">
            <label htmlFor="eyeColor">Eye Color</label>
            <select
              id="eyeColor"
              value={eyeColor}
              onChange={(e) => setEyeColor(e.target.value)}
              className="update-appearance-input"
            >
              <option value="">Select eye color</option>
              {eyeColorOptions.map((color) => (
                <option key={color} value={color}>
                  {color}
                </option>
              ))}
            </select>
          </div>
        </form>
        <div className="update-appearance-popup-footer">
          <button className="update-appearance-save-button" onClick={handleSave}>
            Save
          </button>
          <button className="update-appearance-cancel-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

UpdateAppearance.propTypes = {
  initialInfo: PropTypes.shape({
    height: PropTypes.string,
    weight: PropTypes.string,
    hairColor: PropTypes.string,
    eyeColor: PropTypes.string,
  }),
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateAppearance;